export default {
  setFormData({commit}, payload) {
    commit('SET_FORM_DATA', payload)
  },
  restart({commit}) {
    commit('RESTART')
  },
  setAboutStatus({commit}, payload) {
    commit('SET_ABOUT_STATUS', payload)
  },
  setActiveLocation({commit}, payload) {
    commit('SET_ACTIVE_LOCATION', payload)
  },
  setTopThree({commit}, payload) {
    commit('SET_TOP_THREE', payload)
  },
  setTopPerGenre({commit}, payload) {
    commit('SET_TOP_PER_GENRE', payload)
  },
  resultsFound({commit}, payload) {
    commit('RESULTS_FOUND', payload)
  },
  setResults({commit}, payload) {
    commit('SET_RESULTS', payload)
  }
}